import React, {Component} from 'react'
import utils from '../../utils/utils'
import { Container, Row, Col, Badge} from 'reactstrap'
import moment from 'moment'
import InfoBadge from './InfoBadge'
import _ from 'lodash'

export default class ServerItem extends Component {
  constructor(props, context) {
    super(props, context)
  }
  render(){
    const isPoller = (this.props.worker.worker_type === 'POLLER')
    const momentDuration = moment.duration(Number(new Date().getTime()) - Number(this.props.worker.started))
    const pid = _.last(this.props.worker.instance_id.split('-'))
    let specialItem = []
    let justPollerItem = []
      if (!isPoller) {
       specialItem.push(
        <div key={`jobs-not-poller-${this.props.worker.instance_id}`}>
            <Badge color='primary' className='ms-badge'>
              <h6>{`Jobs:${this.props.worker.jobs_running}`}</h6>
            </Badge>
            <InfoBadge title={`Load Unit`} value={this.props.worker.load_units} type={'none'}/>
          </div>
       )
      } else if (isPoller) {
        specialItem.push(
          <div key={`redis-poller-${this.props.worker.instance_id}`}>
            <Badge color='primary' className={`ms-badge ${utils.getRedisStyles(this.props.worker.redis_status)}`}>
              <h6 className='text-black'>{`REDIS`}</h6>
            </Badge>
            <Badge color='primary' className='ms-badge'>
              <h6>
                {`Queue: ${this.props.worker.queued_tasks || 0}`}
              </h6>
            </Badge>
          </div>
        )
      }
    return(
      <div className="panel panel-default mt5 mb5 text-black">
        <div className="panel-body worker-item-fix">
        <Row className='worker-text'>
        <Col sm='1'>
          <Badge color='primary' className='ms-badge'>
              <h6>{pid}</h6>
          </Badge>
        </Col>
        <Col sm='1'>
        <Badge color='primary' className='ms-badge'>
              <h6>{this.props.worker.worker_type}</h6>
        </Badge>
        </Col>
        <Col sm='3'>
          <Badge color='primary' className='ms-badge'>
              <h6>{this.props.worker.version}</h6>
          </Badge>
        </Col>
        <Col sm='1'>
          <InfoBadge title={(utils.isOnline(this.props.worker.notified)) ? 'Connected':'Offline'} value={this.props.worker.notified} type={'time'}/>
        </Col>
        <Col sm='1'>
        <Badge color='primary' className={`ms-badge ${utils.getPollingStyles(this.props.worker.status)}`}>
              <h6 className='text-black'>{this.props.worker.status}</h6>
        </Badge>
        </Col>
        <Col key={1} sm='3'>
        {specialItem}
        </Col>
        <Col sm={'2'}>
        <Badge color='primary' className='ms-badge'>
            <h6>{`${momentDuration.get("d")} days ${momentDuration.get("h")} hours`}</h6>
        </Badge>
        </Col>
        </Row>
        </div>
      </div>
    )
  }
}


// jobs_running:0 // worker
// load_units:0 // worker
// redis_status:"OK/KO" //Poller


// WEBPACK FOOTER //
// ./src/components/server/WorkerItem.js